var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('component',_vm._b({class:_vm.bem('button', {background: _vm.background, color: _vm.color, radius: _vm.radius})},'component',_vm.bind,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }